import { render } from "./menu_jvta.vue?vue&type=template&id=3782350a&scoped=true"
import script from "./menu_jvta.vue?vue&type=script&lang=js"
export * from "./menu_jvta.vue?vue&type=script&lang=js"

import "./menu_jvta.vue?vue&type=style&index=0&id=3782350a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3782350a"]])

export default __exports__